import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface CouponStore {
  coupon: string | null
  setCoupon: (coupon: string) => void
  clearCoupon: () => void
}

const useCouponStore = create<CouponStore>()(
  persist(
    (set) => ({
      coupon: null,
      setCoupon: (coupon: string) => set({ coupon }),
      clearCoupon: () => set({ coupon: null }),
    }),
    {
      name: 'coupon-store',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

export default useCouponStore
